// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.t86ifTnYh8U836yQnvZK{margin-bottom:4px}.Jzs92KzW4RIqRFH9z5yZ{height:-webkit-max-content;height:max-content;margin-top:2px}.Fpki2aUDB4FdhTmBeA9G{background:var(--background-neutral-subtle);border-radius:6px;justify-content:space-between;align-items:center;width:100%;height:40px;margin-bottom:4px;padding-left:12px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fieldError": `t86ifTnYh8U836yQnvZK`,
	"addButton": `Jzs92KzW4RIqRFH9z5yZ`,
	"header": `Fpki2aUDB4FdhTmBeA9G`
};
export default ___CSS_LOADER_EXPORT___;
